/** PDP size picker: the hidden radio carries the submitted value and the `:checked` state, the button is the visible control — one tab stop per size, which a radio group (a single roving tab stop) cannot give. */
(function () {
  const picker = document.querySelector("[data-variant-picker]");
  if (!picker) return;

  const form = picker.closest("form");
  if (!form) return;

  const buttons = Array.prototype.slice.call(picker.querySelectorAll("[data-variant-button]"));
  if (!buttons.length) return;

  // Same route as the sticky bar and the store-availability drawer: check the radio and let the `change` bubble, so price, add-to-cart and the `?variant=` URL all follow.
  buttons.forEach(function (button) {
    button.addEventListener("click", function () {
      const radio = form.querySelector('input[name="id"][value="' + button.dataset.variantButton + '"]');
      if (!radio || radio.checked) return;
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  // Whoever changed the variant — this picker, the sticky bar or the availability drawer — the pressed state follows.
  form.addEventListener("change", function (event) {
    if (!event.target || event.target.name !== "id") return;

    const checked = form.querySelector('input[name="id"]:checked');
    if (!checked) return;

    buttons.forEach(function (button) {
      button.setAttribute("aria-pressed", String(button.dataset.variantButton === checked.value));
    });
  });
})();
